import { Heading, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { AccordionGroupSingleOpen } from 'src/components/oneCorp/features/MealCredit/common/Accordion/AccordionGroupSingleOpen';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { OrderRestrictionsProvider } from 'src/common/OrderRestrictions/OrderRestrictionsProvider/OrderRestrictionsProvider';
import { CheckoutDisplaySettingsRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/CheckoutDisplaySettingsRule/CheckoutDisplaySettingsRule';
import { DurationsRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/DurationsRule';
import { EmailNotificationRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/EmailNotificationRule/EmailNotificationRule';
import { LocationsRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/LocationsRule';
import { ExpenseSettingsRule } from './ExpenseSettingsRule/ExpenseSettingsRule';
import { OrderSettingsRule } from './OrderSettingsRule/OrderSettingsRule';
import { MerchantRestrictionsRule } from './MerchantRestrictionsRule/MerchantRestrictionsRule';
import { ItemRestrictionsRule } from './ItemRestrictionsRule/ItemRestrictionsRule';

export function Rules(): JSX.Element {
  const { isEditing } = useMealCreditFormData();
  return (
    <>
      <Stack y="x-sm">
        <Heading variant="h6">Rules</Heading>
      </Stack>
      <OrderRestrictionsProvider>
        <AccordionGroupSingleOpen>
          <DurationsRule defaultExpanded={!isEditing} />
          <LocationsRule />
          <OrderSettingsRule />
          <CheckoutDisplaySettingsRule />
          <EmailNotificationRule />
          <ExpenseSettingsRule />
          <MerchantRestrictionsRule />
          <ItemRestrictionsRule />
        </AccordionGroupSingleOpen>
      </OrderRestrictionsProvider>
    </>
  );
}
